<template>
  <div class="row gutter-md lead-mask-config">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
    </div>
  </div>
</template>

<script>
import Field from '@/components/helpers/DataInput/Field'

let defaultConfig = {
  actions: {
  }
}

export default {
  components: {
    Field,
  },
  props: {
    value: {
      type: Object,
      default: () => (defaultConfig)
    }
  },
  computed: {
    config() {
      // Use value prop but also Validate that it contains all necessary attributes
      let configuration = defaultConfig
      if (!this.value.actions) { return configuration }
      Object.keys(this.value.actions).forEach((key) => {
        let hash = this.value.actions[key]
        // If key is not present in defaultConfig we add it
        if (!configuration['actions'][key]) {
          configurations['actions'][key] = hash
        }
        Object.keys(hash).forEach((keyInner) => {
          let valueInner = hash[keyInner]
          configuration['actions'][key][keyInner] = valueInner
        })
      })
      return configuration
    }
  },
  watch: {
    config: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    },
  }
}
</script>

<style lang="scss">
.lead-mask-config {
  select {
    margin: 2px 0 8px !important;
  }
}
.hidden {
  display: none !important;
}

.optionalv{
  display: none!important;
}

.is-inline {
  display: inline;
}

.is-inline-block {
  display: inline-block;
}

.form-label {
  font-size: 1em;
  font-weight: 500;
  line-height: 24px;
  color: #212736;
  padding-bottom: 20px;
  margin-bottom: 20px;
  text-align: left;
}

.float-left {
  float: 'left'
}

.margin-top-bottom {
  margin-top: 20px!important;
  margin-bottom: 20px;
}

.padding-top {
  padding-top: 20px
}

.is-block {
  display: block;
}

.radio {
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// LeadMaskConfiguration.vue?5194ad9c